import { HttpParams } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminService, NamedLogin, PostResponse } from '../../../pages/admin/services/admin.service';
import { ConfirmModalComponent } from '../../shared/confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-named-login-setup-modal',
  templateUrl: './named-login-setup-modal.component.html',
  styleUrls: ['./named-login-setup-modal.component.css']
})

export class NamedLoginSetupModalComponent implements OnInit {
  @ViewChild('changePasswordForm') changePasswordForm: NgForm;

  formData: {
    NamedLogin: string;
    Password: string;
    ConfirmPassword: string;
  };
  alert: { [key: string]: any } | null = null;;
  passwordsMatch: boolean = true;
  addUserMode: boolean = false;
  changePasswordMode: boolean = false;
  performingAction: boolean = false;
  loginLink: string = window.location.origin + "/Account/NamedLogin";
  users: NamedLogin[] = [];

  constructor(
    private readonly adminService: AdminService,
    private readonly activeModalService: NgbActiveModal,
    private readonly modalService: NgbModal,

  ) { }

  async ngOnInit(): Promise<void> {
    this.getNamedLoginList();
    this.formData = { NamedLogin: '', Password: '', ConfirmPassword: '' };
  }

  getNamedLoginList () {
    this.adminService.getNamedLoginList().then((response) => {
      this.users = response;
    });
  }

  toggleAddUserMode (addUserMode) {
    this.addUserMode = addUserMode;
  }


  addUser () {
    this.performingAction = true;
    const params = new HttpParams()
      .set('NamedLogin', this.formData.NamedLogin)
      .set('Password', this.formData.Password)
      .set('ConfirmPassword', this.formData.ConfirmPassword);

    this.adminService.createNamedLogin(params).then((response: PostResponse) => {
      if (response.success) {
        const name = this.formData.NamedLogin;
        this.resetForm();
        this.alert = { type: "success", msg: "User " + name + " has been added." };
        this.getNamedLoginList();
      }
      else {
        this.alert = { type: "danger", msg: response.error };
      }
      this.performingAction = false;
    }).catch((error) => {
      this.performingAction = false;
      this.alert = { type: "danger", msg: error?.error?.error ?? "An error has occured." };
    });
  }

  removeUser (user) {
    const modalRef = this.modalService.open(ConfirmModalComponent, {
      size: "s",
    });
    modalRef.componentInstance.headerText = "Update Manager";
    modalRef.componentInstance.bodyText = `Are you sure you want to remove the user ${user.NamedLogin}?`;
    modalRef.componentInstance.confirmButtontext = "Remove";
    modalRef.componentInstance.cancelButtontext = "Cancel";
    modalRef.result.then((result: boolean) => {
      if (result === true) {
        this.performingAction = true;
        const params = new HttpParams()
          .set('NamedLogin', user.NamedLogin);

        this.adminService.removeNamedLogin(params).then((response: PostResponse) => {
          if (response.success) {
            this.alert = { type: "success", msg: "User " + user.NamedLogin + " has been removed." };
            this.getNamedLoginList();
          }
          else {
            this.alert = { type: "danger", msg: response.error };
          }
          this.performingAction = false
        });
      }
    }).catch((error) => {
      this.performingAction = false;
      this.alert = { type: "danger", msg: error?.error?.error ?? "An error has occured." };
    });
  }

  unlockUser (user) {
    this.performingAction = true;
    const params = new HttpParams()
      .set('userKeyID', user.UserKeyID);

    this.adminService.unlockUser(params).then((response: PostResponse) => {
      if (response.success) {
        this.alert = { type: "success", msg: "User " + user.NamedLogin + " has been unlocked." };
        this.getNamedLoginList();
      }
      else {
        this.alert = { type: "danger", msg: response.error };
      }
      this.performingAction = false
    }).catch((error) => {
      this.performingAction = false;
      this.alert = { type: "danger", msg: error?.error?.error ?? "An error has occured." };
    });
  }

  changePasswordEnable (user) {
    this.alert = null;
    this.formData = { NamedLogin: user.NamedLogin, Password: '', ConfirmPassword: '' };
    this.changePasswordMode = true;
  }

  changePassword () {
    if (!this.changePasswordForm.invalid) {
      this.performingAction = true;
      const params = new HttpParams()
        .set('NamedLogin', this.formData.NamedLogin)
        .set('Password', this.formData.Password)
        .set('ConfirmPassword', this.formData.ConfirmPassword);

      this.adminService.changeNamedLoginPassword(params).then((response: PostResponse) => {
        if (response.success) {
          const user = this.formData.NamedLogin;
          this.alert = { type: "success", msg: "Password for user " + user + " has been changed." };
          this.resetForm();
          this.getNamedLoginList();
        }
        else {
          this.alert = { type: "danger", msg: response.error };
        }
        this.performingAction = false
      }).catch((error) => {
        this.performingAction = false;
        this.alert = { type: "danger", msg: error?.error?.error ?? "An error has occured." };
      });
    }
  }

  confirmPassword() {
    this.passwordsMatch = this.validatePasswords();
  }

  validatePasswords () {
    //do not mark an error if the confirm password hasn't been entered
    if (this.formData.ConfirmPassword == null || this.formData.ConfirmPassword == "")
      return true;

    var passwordsMatch = this.formData.ConfirmPassword === this.formData.Password;
    if (!passwordsMatch)
      this.alert = { type: "danger", msg: "Passwords must match!" };
    return passwordsMatch;
  };

  clearErrors() {
    this.alert = null;
    this.passwordsMatch = true;
  }

  resetForm () {
    this.formData = { NamedLogin: '', Password: '', ConfirmPassword: '' };
    this.toggleAddUserMode(false);
    this.changePasswordMode = false;
  }

  closeAlert() {
    this.alert = null;
  }

  closeModal () {
    this.activeModalService.close()
  }
}
